import "./seperator.css"
export function Seperator(){
    return(<div className="seperator">

    </div>)
}